import { render, staticRenderFns } from "./FavoriteFilterItem.vue?vue&type=template&id=2476a25c&"
import script from "./FavoriteFilterItem.vue?vue&type=script&lang=js&"
export * from "./FavoriteFilterItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports